@charset "UTF-8";

/* src/app/global/components/global-notifications/global-notifications.component.scss */
:host {
  background-color: rgba(0, 0, 0, 0.1);
  cursor: pointer;
  text-align: center;
  width: 60px;
}
:host .cw-global-notification-icon {
  font-size: 2rem;
  line-height: 30px;
}
:host mat-card {
  cursor: default;
  font-size: 1.4rem;
  padding: 0;
  position: absolute;
  right: 65px;
  text-align: left;
  z-index: 200;
  border: 1px solid rgba(0, 0, 0, 0.2);
  min-width: 800px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
}
:host mat-card .cw-flex-row {
  position: relative;
  padding: 5px 16px;
  width: 100%;
}
:host mat-card .icon-spinner {
  margin-bottom: 16px;
  margin-left: 16px;
}
:host .cw-notification-header {
  border-bottom: 1px solid var(--color-accent);
}
:host mat-list {
  overflow-y: auto;
  max-height: 600px;
  padding: 0;
}
:host mat-list mat-list-item:last-of-type mat-divider {
  display: none;
}
:host .cw-toolbar {
  cursor: default;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex: 1 1;
  -webkit-flex-direction: row;
  flex-direction: row;
  justify-content: flex-end;
  margin: 0 0 5px 0;
  text-align: right;
  width: 100%;
}
:host .cw-toolbar-icon {
  align-items: center;
  color: var(--color-primary-dark);
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  font-size: 18px;
  justify-content: center;
  margin-left: 5px;
}
:host .cw-toolbar-icon:active {
  background-color: var(--color-primary-dark);
  color: var(--color-default-light);
}
:host mat-list ::ng-deep .notification-fix {
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 10px;
}
.cw-notification-icon {
  line-height: 48px;
  cursor: pointer;
}
.marginLeftTenPx {
  margin-left: 10px;
}
mat-list div.cw-flex-row {
  align-items: center;
}
.strikethrough:after {
  content: "";
  position: absolute;
  display: block;
  top: calc(50% - 0.15em);
  width: 80%;
  height: 2px;
  box-shadow: 0 1px rgba(255, 255, 255, 0.6);
  background: #b0b0b0;
  transform-origin: left center;
  animation: strikethrough 1s cubic-bezier(0.55, 0, 0.1, 1) 1;
  left: 40px;
}
mat-list-item {
  color: var(--color-default-dark);
}
mat-list-item .strikethrough {
  color: #b0b0b0;
}
@keyframes strikethrough {
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
}
@keyframes jiggle {
  0% {
    transform: rotate(-10deg);
  }
  50% {
    transform: rotate(10deg);
  }
  100% {
    transform: rotate(-10deg);
  }
}
.jiggleIcon {
  animation: jiggle 1s ease infinite;
}
.matBadgePosition {
  transform: translate(2px, -15px);
}
.mat-badge-content {
  color: var(--color-default-dark);
}
.cw-flex-row {
  border-bottom: 1px solid var(--color-primary-lighter);
}
.shadow {
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
}
.disableclick {
  pointer-events: none;
  color: var(--color-primary) !important;
}
.clickable-wrapper {
  display: flex;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
  width: 100%;
  margin: 5px 5px;
}
.clickable-wrapper:hover {
  background-color: #e0e0e0;
}
.global-notification-row {
  margin: 0px !important;
  padding: 0px 0px 0px 15px !important;
}
.global-notification-checkbox {
  transform: translateY(3px);
}
.global-notification-icon {
  transform: translateY(0px);
}
.global-notification-item {
  transform: translateY(2px);
}
/*# sourceMappingURL=global-notifications.component.css.map */
